import { useInspectionStore } from "@/stores/inspection";
import { convertToInt } from "@/composables/util";
import { clone } from "@/util/clone";
import { STRUCTURE_UNIT_TYPE } from "@/constants/Inspections";
import { convertStructureUnitsToLocations } from "@/composables/spanBySpan";

export function sort(arr) {
  arr.value = arr.value?.sort(function (a, b) {
    return a?.strUnitKey - b?.strUnitKey || a?.fcKey - b?.fcKey;
  });
}

export function getFcDetails(unitKey, inspectionFCs) {
  let fcDetails = [];
  fcDetails = inspectionFCs ? clone(inspectionFCs) : [];

  if (unitKey) {
    fcDetails = fcDetails?.filter((a) => a?.strUnitKey === unitKey);
  }

  if (!fcDetails?.[0]) {
    //remove null values from array(if any)
    fcDetails = fcDetails ? fcDetails.filter((a) => !!a) : [];
  }
  //set unique key for toggle expansion
  if (fcDetails) {
    for (const element of fcDetails ?? []) {
      element.uniqueKey = element?.strUnitKey + "-" + element?.fcKey;
      element.readOnly = true;
    }
    sort(fcDetails);
  } else {
    fcDetails = [];
  }
  return fcDetails;
}

export function getFcDetailsReport(unitKey) {
  let fcDetails = [];
  const inspectionStore = useInspectionStore();
  const structure = inspectionStore.selectedInspection;
  if (unitKey) {
    fcDetails = structure?.inspectionFCs
      ? clone(structure?.inspectionFCs?.filter((a) => a?.strUnitKey === unitKey))
      : [];
  } else {
    fcDetails = structure?.inspectionFCs ? clone(structure?.inspectionFCs) : [];
  }
  if (!fcDetails?.[0]) {
    //remove null values from array(if any)
    fcDetails = fcDetails ? fcDetails.filter((a) => !!a) : [];
  }
  //set unique key for toggle expansion
  if (fcDetails) {
    for (const element of fcDetails ?? []) {
      element.uniqueKey = element?.strUnitKey + "-" + element?.fcKey;
      element.readOnly = true;
    }
    sort(fcDetails);
  } else {
    fcDetails = [];
  }
  return fcDetails;
}

export function locationOptions(modelValue, isNumericValue) {
  const inspectionStore = useInspectionStore();
  const locations = convertStructureUnitsToLocations(
    inspectionStore.getFilteredStructureUnits([STRUCTURE_UNIT_TYPE.APRAS_SPAN], false)
  );
  const item = modelValue
    ? locations.find((selectItem) => selectItem.value?.toString() == modelValue?.toString()?.trimEnd())
    : null;
  if (item) {
    return item?.title;
  } else {
    //if isNumericValue=true return the int format of computed value
    return isNumericValue ? Number.parseInt(modelValue) || -1 : modelValue;
  }
}

export function fctotalCrfMain() {
  const inspectionStore = useInspectionStore();
  const structure = inspectionStore.selectedInspection;
  return (
    convertToInt(structure?.userBridge?.mainCRFMemType) +
    convertToInt(structure?.userBridge?.mainCRFFatigSus) +
    convertToInt(structure?.userBridge?.mainCRFMaterial) +
    convertToInt(structure?.userBridge?.mainCRFCumAdtt)
  );
}
export function fctotalCrfApproach() {
  const inspectionStore = useInspectionStore();
  const structure = inspectionStore.selectedInspection;
  return (
    convertToInt(structure?.userBridge?.apprCRFMemType) +
    convertToInt(structure?.userBridge?.apprCRFFatigSus) +
    convertToInt(structure?.userBridge?.apprCRFMaterial) +
    convertToInt(structure?.userBridge?.apprCRFCumAdtt)
  );
}
export function fctotalCrfMainString() {
  const inspectionStore = useInspectionStore();
  const structure = inspectionStore.selectedInspection;
  return (
    (structure?.userBridge?.mainCRFMemType ?? "") +
    (structure?.userBridge?.mainCRFFatigSus ?? "") +
    (structure?.userBridge?.mainCRFMaterial ?? "") +
    (structure?.userBridge?.mainCRFCumAdtt ?? "")
  );
}
export function fctotalCrfApproachString() {
  const inspectionStore = useInspectionStore();
  const structure = inspectionStore.selectedInspection;
  return (
    (structure?.userBridge?.apprCRFMemType ?? "") +
    (structure?.userBridge?.apprCRFFatigSus ?? "") +
    (structure?.userBridge?.apprCRFMaterial ?? "") +
    (structure?.userBridge?.apprCRFCumAdtt ?? "")
  );
}
export function setFatigueDetails() {
  const inspectionStore = useInspectionStore();
  const structure = inspectionStore.selectedInspection;
  const fcDetailE = structure?.inspectionFCs?.find(
    (detail) => detail?.fatigStressCat?.trim() == "E" || detail?.fatigStressCat?.trim() == "E'"
  );
  if (fcDetailE) {
    structure.userInspection.fatiguedetails = "Y";
  } else {
    structure.userInspection.fatiguedetails = "N";
  }
}

export function fatigueDetail() {
  const inspectionStore = useInspectionStore();
  const structure = inspectionStore.selectedInspection;
  setFatigueDetails();
  return structure?.userInspection?.fatiguedetails;
}
